import { toRefs as C, computed as I, unref as b, resolveComponent as s, openBlock as o, createElementBlock as d, Fragment as c, renderSlot as g, normalizeProps as B, guardReactiveProps as D, createTextVNode as S, createBlock as u, Teleport as k, createVNode as E, mergeProps as _, withCtx as y, renderList as R, createCommentVNode as h } from "vue";
/* empty css                    */
import v from "./design-system.es128.js";
import w from "./design-system.es69.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import { useMenuProvider as x } from "./design-system.es293.js";
/* empty css                    */
/* empty css                    */
import A from "./design-system.es74.js";
import N from "./design-system.es75.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
/* empty css                    */
import { bottomStart as M, rightStart as O, rightEnd as V, leftStart as F, leftEnd as T, bottomEnd as j, topStart as q, topEnd as z } from "./design-system.es294.js";
const L = {
  name: "DsDropdownDefault",
  components: {
    MenuContainer: w,
    MenuItems: N,
    MenuItem: A
  },
  inheritAttrs: !1,
  props: {
    /**
     * Controls the open state of the dropdown.  This makes the dropdown controlled and will not work with uncontrolled options.
     */
    isOpen: {
      type: Boolean,
      default: null
    },
    /**
     * Enables dense menu items
     */
    dense: Boolean,
    /**
     * Determines if the menu should be fixed size and scroll vertically or size to fit the number of options.
     */
    scroll: {
      type: Boolean,
      default: !0
    },
    /**
     * Determines if the menu should fill the width of the container.  This will also cause the dropdown to turn off teleport behavior.
     */
    fill: Boolean,
    /**
     * Position the dropdown either left aligned or right aligned below its reference
     */
    position: {
      type: String,
      default: M,
      options: [
        O,
        V,
        F,
        T,
        M,
        j,
        q,
        z
      ]
    },
    /**
     * Offset the dropdown from its reference.  Corresponds to Popper's offset modifier.  https://popper.js.org/docs/v2/modifiers/offset/
     */
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    /**
     * Reference to the trigger element.  This is used for advanced cases where the trigger ref may be used for more than just the trigger.
     */
    triggerRef: {
      type: Object,
      default: null
    },
    /**
     * Items to display in the dropdown.  This is an array of objects that will be passed to the MenuItem component.
     */
    items: {
      type: Array,
      default: null
    },
    /**
     * Function to map items object to MenuItem props for rendering.  This is useful when the items object does not match the MenuItem props.
     */
    mapItem: {
      type: Function,
      default: (e) => e
    }
  },
  emits: ["close"],
  setup(e, { emit: r, attrs: t }) {
    const {
      triggerRef: n,
      isOpen: a,
      dense: f,
      offset: m,
      position: l
    } = C(e), {
      triggerProps: p,
      menuProps: i
    } = x({
      trigger: n,
      isOpen: a,
      dense: f,
      position: l,
      offset: m,
      onRequestClose: () => {
        r("close");
      }
    }), P = I(() => ({
      ...t,
      ...b(i)
    }));
    return {
      triggerProps: p,
      menuProps: P
    };
  }
};
function G(e, r, t, n, a, f) {
  const m = s("MenuItem"), l = s("MenuItems"), p = s("MenuContainer");
  return o(), d(c, null, [
    g(e.$slots, "default", B(D(n.triggerProps))),
    r[0] || (r[0] = S()),
    (o(), u(k, {
      to: "body",
      disabled: t.fill
    }, [
      E(p, _(n.menuProps, {
        scroll: t.scroll,
        fill: t.fill
      }), {
        default: y(() => [
          g(e.$slots, "content", {}, () => [
            t.items ? (o(), u(l, { key: 0 }, {
              default: y(() => [
                (o(!0), d(c, null, R(t.items.map(t.mapItem), (i) => (o(), u(m, _({
                  key: i.title,
                  ref_for: !0
                }, i), null, 16))), 128))
              ]),
              _: 1
            })) : h("", !0)
          ])
        ]),
        _: 3
      }, 16, ["scroll", "fill"])
    ], 8, ["disabled"]))
  ], 64);
}
const Bt = /* @__PURE__ */ v(L, [["render", G]]);
export {
  Bt as default
};
//# sourceMappingURL=design-system.es343.js.map
